import { useEffect, useMemo } from "react";
import styled from "styled-components";
import CommonCell from "../../common/CommonCell";
import { TriIcon } from "../../icon/Icons";
import ContentPage from "./ContentPage";
import ChatRoom from "../ChatRoom";
import { useDispatch, useSelector } from "react-redux";
import { userColors } from "../../util/colors";
import sheet from "../../images/sheet.jpg";
import { commonAction } from "../../slices/GameSlice";
import { useParams } from "react-router-dom";

const CellContent = () => {
  const { users, workMode, roomId } = useSelector((state) => state.GameSlice);
  const { userId } = useSelector((state) => state.LoginInfoSlice);
  const dispatch = useDispatch();
  const param = useParams();

  const ColumnArr = useMemo(() => {
    let arr = [];
    for (let i = 1; i < 40; i++) {
      arr.push(i);
    }
    return arr;
  }, []);
  const RowArr = useMemo(() => {
    const alphabetArray = [];
    for (let i = 65; i <= 90; i++) {
      alphabetArray.push(String.fromCharCode(i));
    }

    const extendedAlphabetArray = [...alphabetArray];

    alphabetArray.forEach((letter) => {
      extendedAlphabetArray.push("A" + letter);
    });
    return extendedAlphabetArray;
  }, []);

  useEffect(() => {
    dispatch(commonAction({ target: "roomId", value: param?.roomId || "" }));
  }, [param, dispatch]);

  return (
    <Wrap>
      <RowContainer>
        <ColumnCell>
          <TriIcon />
        </ColumnCell>
        {RowArr.map((item) => (
          <CommonCell
            key={`${item}rowCellKey`}
            styles={{
              borderTop: "none",
              background: "none",
              color: "#616161",
              borderBottom: "1px solid #BABABA",
              translate: "1px 0",
            }}
          >
            {item}
          </CommonCell>
        ))}
      </RowContainer>

      <MiddleContainer>
        <ColumnContainer style={{ borderRight: "1px solid #BABABA" }}>
          {ColumnArr.map((item) => (
            <ColumnCell key={`${item}columnCellKey`}>{item}</ColumnCell>
          ))}
        </ColumnContainer>
        <ColumnContainer>
          {ColumnArr.map((item, index) => {
            const findUser = users.find((i) => i?.order === index);
            const userColor = userColors[findUser?.order] || "#fff";
            const checkSelf = findUser?.userId === userId;

            return (
              <CommonCell
                styles={{
                  background:
                    !workMode &&
                    `linear-gradient(135deg, ${userColor} 5px, #fff 0)`,
                  border: !workMode && checkSelf && "1px solid #107C41",
                }}
                key={`${item}nicknameCellKey`}
              >
                {!workMode && findUser?.nickname}
              </CommonCell>
            );
          })}
        </ColumnContainer>
        <CellsContainer key={"cellContainer"} id="cellContainer">
          {roomId && <SheetImg src={sheet} alt="sheet" />}
          {roomId && <ContentPage />}
          {roomId && <ChatRoom />}

          {ColumnArr.map((_, firstIndex) => (
            <RowContainer key={`${firstIndex}CellsRowKeys`}>
              {RowArr.map((secondItem) => (
                <CommonCell key={`${secondItem}secondRowKey`} />
              ))}
            </RowContainer>
          ))}
        </CellsContainer>
      </MiddleContainer>
    </Wrap>
  );
};

export default CellContent;

const Wrap = styled.div`
  width: 100%;
  height: 620px;
  display: flex;
  margin-top: 15px;
  overflow: hidden;
  flex-direction: column;
`;
const RowContainer = styled.div`
  display: flex;
`;
const MiddleContainer = styled.div`
  width: 100%;
  display: flex;
`;
const CellsContainer = styled.div`
  width: 1866px;
  height: 600px;
  /* overflow: auto; */
  position: relative;
  display: flex;
  flex-direction: column;
`;

const SheetImg = styled.img`
  width: 1167px;
  height: 818px;
  position: absolute;
  left: 0;
  top: 0;
`;

const ColumnCell = styled.div`
  width: 42px;
  min-width: 42px;
  height: 21px;
  display: flex;
  padding: 3px;
  justify-content: end;
  color: #616161;
  border: 1px solid #e0e0e0;
  border-left: none;
  border-top: none;
  font-size: 13px;
  line-height: 15px;
`;
const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
